// Mock data for SAE Agro Equipment website

export const translations = {
  en: {
    nav: {
      home: 'Home',
      equipment: 'Equipment',
      services: 'Services',
      references: 'References',
      partners: 'Our Partners',
      becomePartner: 'Become a Partner',
      clientFeedback: 'Client Feedback',
      events: 'Events',
      contact: 'Contact'
    },
    hero: {
      tagline: 'Specialist in industrial and agricultural spare parts and equipment',
      subtitle: 'Official Distributor of World-Class Brands',
      cta: 'Discover Our Products'
    },
    about: {
      title: 'Who We Are',
      content: `SARL AGRO-EQUIPEMENT .SAE. (IMPORT-EXPORT) is an Algerian company based in western Algeria:
Zone des siéges, Coopérative Immobilière AL HOGAR N°01, Lot N°04, USTO - ORAN, ALGERIA.

Specialist in Agricultural & Industrial equipment and spare parts.
Official and exclusive distributor of IRIS CHAINS.
Official distributor of RIMA GROUP, SKF, NTN-SNR, MAHLE, MS MOTORSERVICES, AM GEARS S.R.L, and TAGEX.

SAE has been active in the agricultural and industrial sector since January 1998, with staff having over twenty years of experience.

SAE's objective is to contribute to the development of national agriculture and industry through the marketing of equipment and spare parts for tractors, combine harvesters, and industrial machines.`,
      values: [
        'Permanent customer assistance (study and advice on equipment selection)',
        'Wide range of quality agricultural & industrial equipment and spare parts',
        'After-sales service with on-site repair and troubleshooting',
        'Preventive equipment maintenance'
      ],
      motto: 'SAE is your dedicated partner in achieving and satisfying your projects.'
    },
    services: {
      title: 'Our Services',
      subtitle: 'In our quest to provide the best adapted professional solutions to meet our customers\' needs, AGRO EQUIPEMENT offers its clients various services and products.',
      list: [
        {
          title: 'Sales & Supplies',
          description: 'Sale and supply of agricultural and industrial equipment and spare parts.'
        },
        {
          title: 'Personalized Support',
          description: 'Personal attention to customers with continuous follow-up.'
        },
        {
          title: 'Customer Training',
          description: 'Customer training in combination with our suppliers.'
        },
        {
          title: 'Installation & Maintenance',
          description: 'Installation and maintenance of livestock feed mixers and grinders.'
        },
        {
          title: 'Equipment Assembly',
          description: 'Assembly and demonstration of agricultural equipment acquired by our customers.'
        },
        {
          title: 'After-Sales Service',
          description: 'After-sales service coverage throughout the national territory.'
        }
      ]
    },
    equipment: {
      title: 'Equipment',
      categories: [
        { id: 'sampo', name: 'SAMPO Parts' },
        { id: 'claas', name: 'CLAAS Parts' },
        { id: 'tractors', name: 'Tractor Parts' },
        { id: 'skf', name: 'SKF Bearings' }
      ]
    },
    references: {
      title: 'Our References',
      subtitle: 'Trusted by leading companies across Algeria'
    },
    partners: {
      title: 'Our Partners',
      subtitle: 'We collaborate with world-renowned brands to bring you the best quality products'
    },
    becomePartner: {
      title: 'Become a Partner',
      subtitle: 'Please fill out the form, and send us your proposal. We will contact you as soon as possible...',
      form: {
        companyName: 'Company Name',
        fullName: 'Full Name',
        address: 'Address',
        email: 'Email Address',
        phone: 'Phone Number',
        capital: 'Social Capital',
        message: 'Message',
        submit: 'Send Information'
      }
    },
    clientFeedback: {
      title: 'Client Feedback',
      questions: {
        q1: 'How did you hear about AGRO EQUIPEMENT (SAE)?',
        q1Options: ['Poster', 'Internet', 'Press', 'Fairs & Exhibitions'],
        q2: 'What do you think of the quality of our services?',
        q2Options: ['Good', 'Average', 'Poor'],
        q3: 'If Poor, please list the weak points you have noticed:'
      },
      submit: 'Send Feedback'
    },
    events: {
      title: 'Events',
      noEvents: 'SARL AGRO-EQUIPEMENT .SAE. (IMPORT-EXPORT) - No Events Currently'
    },
    contact: {
      title: 'Contact',
      manager: 'Manager',
      commercialManager: 'Commercial Manager',
      address: 'Address',
      salesPoint1: 'Sales Point N°01',
      salesPoint2: 'Sales Point N°02',
      secretaries: 'Administrative Secretaries',
      form: {
        title: 'Contact Form',
        name: 'Your Name',
        email: 'Your Email',
        subject: 'Subject',
        message: 'Message',
        submit: 'Send'
      }
    },
    footer: {
      rights: 'All Rights Reserved',
      company: 'SAE Agro Equipment'
    }
  },
  fr: {
    nav: {
      home: 'Accueil',
      equipment: 'Équipements',
      services: 'Services',
      references: 'Références',
      partners: 'Nos Partenaires',
      becomePartner: 'Devenir Partenaire',
      clientFeedback: 'Écoute Clients',
      events: 'Événements',
      contact: 'Contact'
    },
    hero: {
      tagline: 'Spécialiste du matériel et de la pièce de rechange industriels et agricoles',
      subtitle: 'Distributeur Officiel de Marques de Renommée Mondiale',
      cta: 'Découvrir Nos Produits'
    },
    about: {
      title: 'Qui Sommes-Nous ?',
      content: `SARL AGRO-EQUIPEMENT .SAE. (IMPORT-EXPORT) Société de droit Algérien, basée dans l'ouest Algérien :
Zone des siéges, Coopérative Immobilière AL HOGAR N°01, Lot N°04, lieu dit USTO - ORAN, ALGÉRIE.

Spécialiste du matériel et de la pièce de rechange Agricole & Industrielle.
Distributeur officiel et exclusif d'IRIS CHAINS.
Distributeur officiel RIMA GROUP, SKF, NTN-SNR, MAHLE, MS MOTORSERVICES, AM GEARS S.R.L, TAGEX.

SAE active dans le secteur agricole et industriel depuis sa création en Janvier 1998, avec un personnel possédant une expérience de plus de vingt années.

L'objectif de SAE est de contribuer au développement de l'agriculture et de l'industrie nationale par le biais de la commercialisation du matériel et des pièces de rechange pour tracteur, moissonneuse batteuse & machines industrielles.`,
      values: [
        'Une assistance permanente à ses clients (étude et conseil au choix des équipements)',
        'Une mise à disposition d\'une large gamme d\'équipements et pièces de rechange agricoles & industrielles de qualité',
        'Un service après-vente avec réparation et dépannage sur site',
        'Une maintenance préventive des équipements'
      ],
      motto: 'SAE est votre partenaire dévoué dans la réalisation et la satisfaction de vos projets.'
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Dans notre quête de fournir des solutions professionnelles les mieux adaptées pour répondre aux besoins de nos clients, AGRO EQUIPEMENT propose à ses clients divers services et produits.',
      list: [
        {
          title: 'Vente et Fournitures',
          description: 'Vente et fournitures de matériels et pièces de rechange Agricole et industrielles.'
        },
        {
          title: 'Attention Personnalisée',
          description: 'Une attention personnelle aux clients avec un suivi continu.'
        },
        {
          title: 'Formation Clientèle',
          description: 'Formation à la clientèle en combinaison avec nos fournisseurs.'
        },
        {
          title: 'Installation et Maintenance',
          description: 'Installation et maintenance de broyeurs mélangeurs pour aliments de bétails.'
        },
        {
          title: 'Montage d\'Équipements',
          description: 'Montage et vulgarisation d\'équipements agricoles acquis par nos clients.'
        },
        {
          title: 'Service Après-Vente',
          description: 'Couverture du S.A.V sur tout le territoire national.'
        }
      ]
    },
    equipment: {
      title: 'Équipements',
      categories: [
        { id: 'sampo', name: 'Pièces SAMPO' },
        { id: 'claas', name: 'Pièces CLAAS' },
        { id: 'tractors', name: 'Pièces Tracteurs' },
        { id: 'skf', name: 'Roulements SKF' }
      ]
    },
    references: {
      title: 'Nos Références',
      subtitle: 'Nous avons la confiance des entreprises leaders en Algérie'
    },
    partners: {
      title: 'Nos Partenaires',
      subtitle: 'Nous collaborons avec des marques de renommée mondiale pour vous offrir des produits de la meilleure qualité'
    },
    becomePartner: {
      title: 'Devenir Partenaire',
      subtitle: 'Veuillez remplir le formulaire, et envoyez nous votre proposition. Nous vous contacterons le plus tôt possible...',
      form: {
        companyName: 'Raison Sociale',
        fullName: 'Nom Complet',
        address: 'Adresse',
        email: 'Adresse Email',
        phone: 'Numéro de Téléphone',
        capital: 'Capital Social',
        message: 'Message',
        submit: 'Envoyer les Informations'
      }
    },
    clientFeedback: {
      title: 'Écoute Clients',
      questions: {
        q1: 'Comment avez-vous connu la Sarl AGRO EQUIPEMENT (SAE) ?',
        q1Options: ['Affiche', 'Internet', 'Presse', 'Foires & Expositions'],
        q2: 'Que pensez-vous de la qualité de nos services ?',
        q2Options: ['Bonne', 'Moyenne', 'Mauvaise'],
        q3: 'Si la réponse est Mauvaise, énumérez les points faibles que vous avez constatés :'
      },
      submit: 'Envoyer les Informations'
    },
    events: {
      title: 'Événements',
      noEvents: 'SARL AGRO-EQUIPEMENT .SAE. (IMPORT-EXPORT) - AUCUN Événement'
    },
    contact: {
      title: 'Contact',
      manager: 'Gérant',
      commercialManager: 'Responsable Commercial',
      address: 'Adresse',
      salesPoint1: 'Point de Vente N°01',
      salesPoint2: 'Point de Vente N°02',
      secretaries: 'Secrétaires Administratives',
      form: {
        title: 'Formulaire de Contact',
        name: 'Votre Nom',
        email: 'Votre Email',
        subject: 'Sujet',
        message: 'Message',
        submit: 'Envoyer'
      }
    },
    footer: {
      rights: 'Tous Droits Réservés',
      company: 'SAE Agro Equipment'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      equipment: 'المعدات',
      services: 'الخدمات',
      references: 'المراجع',
      partners: 'شركاؤنا',
      becomePartner: 'كن شريكاً',
      clientFeedback: 'آراء العملاء',
      events: 'الفعاليات',
      contact: 'اتصل بنا'
    },
    hero: {
      tagline: 'متخصصون في المعدات وقطع الغيار الزراعية والصناعية',
      subtitle: 'الموزع الرسمي للعلامات التجارية العالمية',
      cta: 'اكتشف منتجاتنا'
    },
    about: {
      title: 'من نحن',
      content: `شركة أغرو إكيبمنت .SAE. (استيراد-تصدير) شركة جزائرية مقرها في غرب الجزائر:
منطقة المقرات، التعاونية العقارية الهوقار رقم 01، قطعة رقم 04، أوستو - وهران، الجزائر.

متخصصون في المعدات وقطع الغيار الزراعية والصناعية.
الموزع الرسمي والحصري لـ IRIS CHAINS.
الموزع الرسمي لـ RIMA GROUP، SKF، NTN-SNR، MAHLE، MS MOTORSERVICES، AM GEARS S.R.L، TAGEX.

SAE نشطة في القطاع الزراعي والصناعي منذ تأسيسها في يناير 1998، مع طاقم ذو خبرة تزيد عن عشرين عاماً.`,
      values: [
        'مساعدة دائمة للعملاء (دراسة ونصائح لاختيار المعدات)',
        'توفير مجموعة واسعة من المعدات وقطع الغيار الزراعية والصناعية عالية الجودة',
        'خدمة ما بعد البيع مع الإصلاح في الموقع',
        'الصيانة الوقائية للمعدات'
      ],
      motto: 'SAE شريكك المخلص في تحقيق وإرضاء مشاريعك.'
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'في سعينا لتقديم أفضل الحلول المهنية الملائمة لتلبية احتياجات عملائنا، تقدم أغرو إكيبمنت لعملائها خدمات ومنتجات متنوعة.',
      list: [
        { title: 'المبيعات والتوريدات', description: 'بيع وتوريد المعدات وقطع الغيار الزراعية والصناعية.' },
        { title: 'الدعم الشخصي', description: 'اهتمام شخصي بالعملاء مع متابعة مستمرة.' },
        { title: 'تدريب العملاء', description: 'تدريب العملاء بالتعاون مع موردينا.' },
        { title: 'التركيب والصيانة', description: 'تركيب وصيانة خلاطات وطواحين أعلاف الماشية.' },
        { title: 'تجميع المعدات', description: 'تجميع وعرض المعدات الزراعية المقتناة من قبل عملائنا.' },
        { title: 'خدمة ما بعد البيع', description: 'تغطية خدمة ما بعد البيع على كامل التراب الوطني.' }
      ]
    },
    equipment: {
      title: 'المعدات',
      categories: [
        { id: 'sampo', name: 'قطع غيار SAMPO' },
        { id: 'claas', name: 'قطع غيار CLAAS' },
        { id: 'tractors', name: 'قطع غيار الجرارات' },
        { id: 'skf', name: 'محامل SKF' }
      ]
    },
    references: {
      title: 'مراجعنا',
      subtitle: 'نحظى بثقة الشركات الرائدة في الجزائر'
    },
    partners: {
      title: 'شركاؤنا',
      subtitle: 'نتعاون مع علامات تجارية عالمية لنقدم لكم منتجات بأفضل جودة'
    },
    becomePartner: {
      title: 'كن شريكاً',
      subtitle: 'يرجى ملء النموذج وإرسال اقتراحكم. سنتواصل معكم في أقرب وقت ممكن...',
      form: {
        companyName: 'اسم الشركة',
        fullName: 'الاسم الكامل',
        address: 'العنوان',
        email: 'البريد الإلكتروني',
        phone: 'رقم الهاتف',
        capital: 'رأس المال',
        message: 'الرسالة',
        submit: 'إرسال المعلومات'
      }
    },
    clientFeedback: {
      title: 'آراء العملاء',
      questions: {
        q1: 'كيف سمعت عن أغرو إكيبمنت (SAE)؟',
        q1Options: ['ملصق', 'إنترنت', 'صحافة', 'معارض'],
        q2: 'ما رأيك في جودة خدماتنا؟',
        q2Options: ['جيدة', 'متوسطة', 'سيئة'],
        q3: 'إذا كانت سيئة، يرجى ذكر النقاط الضعيفة:'
      },
      submit: 'إرسال الرأي'
    },
    events: {
      title: 'الفعاليات',
      noEvents: 'شركة أغرو إكيبمنت .SAE. - لا توجد فعاليات حالياً'
    },
    contact: {
      title: 'اتصل بنا',
      manager: 'المدير',
      commercialManager: 'المدير التجاري',
      address: 'العنوان',
      salesPoint1: 'نقطة البيع رقم 01',
      salesPoint2: 'نقطة البيع رقم 02',
      secretaries: 'السكرتاريات الإدارية',
      form: {
        title: 'نموذج الاتصال',
        name: 'اسمك',
        email: 'بريدك الإلكتروني',
        subject: 'الموضوع',
        message: 'الرسالة',
        submit: 'إرسال'
      }
    },
    footer: {
      rights: 'جميع الحقوق محفوظة',
      company: 'SAE أغرو إكيبمنت'
    }
  }
};

export const contactInfo = {
  manager: {
    name: 'Mr ASSAL Adel',
    phones: ['+213 770 978 522', '+213 561 666 588']
  },
  commercial: {
    name: 'Mr Niar Med Reda',
    phone: '0561 734 839',
    email: 'niarmed@sae-dz.com'
  },
  mainAddress: 'Zone des siéges, Coopérative Immobilière AL HOGAR N°01, Lot N°04 lieu dit USTO - ORAN, ALGERIE',
  mainPhone: '+213 (41) 706 906',
  mainEmail: 'contact@sae-dz.com',
  altEmail: 'sarlagroequipement@yahoo.fr',
  salesPoints: [
    'Zone des siéges, Coopérative Immobilière AL HOGAR N°01, Lot N°03 lieu dit USTO - ORAN, ALGERIE',
    'Route de Missergine N° 12 Es-Senia ORAN'
  ],
  secretaries: [
    {
      name: 'Mlle Soumia BENSMIR',
      phone: '+213 560 119 069',
      email: 'soumia.bensmir@sae-dz.com'
    },
    {
      name: 'Mlle Asmaa MEKKI',
      phone: '+213 561 666 585',
      email: 'mekkiasmaa@sae-dz.com'
    }
  ]
};

export const partners = [
  {
    id: 'skf',
    name: 'SKF',
    country: 'France',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-skf.jpg',
    website: 'https://www.skf.com/africa/fr',
    description: {
      en: 'Since 1907, SKF has been a world leader as a technology supplier. Their main strength lies in their ability to continuously develop new technologies and use them to create products that offer highly competitive advantages to their customers.',
      fr: 'Depuis 1907, SKF se place en leader mondial en tant que fournisseur de technologies. Sa principale force réside dans leur capacité à développer en permanence de nouvelles technologies puis à les utiliser afin de créer des produits offrant des avantages très compétitifs à ses clients.'
    },
    fullDescription: {
      en: `Since 1907, SKF has been a world leader as a technology supplier. Their main strength lies in their ability to continuously develop new technologies and use them to create products that offer highly competitive advantages to their customers.

For this purpose, they have field experience in more than 40 industrial sectors and expertise in the following technological platforms: bearings and bearing units, sealing solutions, mechatronics, services and lubrication systems. Their success is based on this know-how.

SAE is the official representative of SKF France in Algeria.

With SAE, you can:
- Get information about SKF bearings (application, frequency...)
- Get the best prices on SKF bearings
- Get the best delivery times on SKF bearings`,
      fr: `Depuis 1907, SKF se place en leader mondial en tant que fournisseur de technologies. Sa principale force réside dans leur capacité à développer en permanence de nouvelles technologies puis à les utiliser afin de créer des produits offrant des avantages très compétitifs à ses clients.

Pour ce faire, elle a une expérience sur le terrain dans plus de 40 secteurs industriels et un savoir-faire dans les plates-formes technologiques suivantes : roulements et ensembles roulements, solutions d'étanchéité, mécatronique, services et systèmes de lubrification.

SAE est représentant officiel de SKF France en Algérie.

Avec SAE, vous pouvez :
- Avoir des informations concernant les roulements SKF (Application, fréquence...)
- Avoir les meilleurs prix sur les roulements SKF
- Avoir les meilleurs délais de livraison sur les roulements SKF`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/skf-dist.jpg',
      'https://www.sae-dz.com/files/pagepart/skf2.jpg'
    ]
  },
  {
    id: 'rima',
    name: 'RIMA',
    country: 'Italy',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-rima.jpg',
    website: 'https://www.rima-parts.com/',
    description: {
      en: 'RIMA has been dedicated since its foundation in 1938 to the design and manufacturing of roller chains, conveyor chains and high-performance agricultural chains.',
      fr: 'RIMA se consacre depuis sa fondation en 1938 à la conception et fabrication des chaînes à rouleaux, des chaînes de transport et des chaînes agricoles de haute performance.'
    },
    fullDescription: {
      en: `1938: Giuseppe Sartirana, founder of the company, begins repairing horse-drawn vehicles.
1950: With the rapid evolution of agricultural mechanization in Italy, the company's main activity changes. Under the name A.R.M.A, the company begins producing side hay rakes, hay tedders and rakes, mowers.
1952: ARMA presents Europe's first motor swather, the "Velox," at the important international trade fair in Milan.
1972: The decision to change the company's main activity from small machine production concentrates all efforts and investments in the production and distribution of a wide range of cutting components for all types of harvesting machines. This marks a change in the company's name to Ri.Ma, acronym for "Ricambi Machine Agricole" - meaning spare parts for agricultural machinery.

The new company strategy leads Ri.Ma to approach new European countries and, overseas, Central/South America.`,
      fr: `1938 : Giuseppe Sartirana fondateur de la compagnie commence à réparer les véhicules hippomobiles.
1950 : Avec l'évolution rapide de la mécanisation d'agriculture en Italie, l'activité principale de compagnie change. Avec le nom d'A.R.M.A la compagnie commence à produire les râteaux à foin latéraux, faneuses de foin et les râteaux, des tondeuses.
1952 : ARMA présente, pendant l'importante exposition de commerce international à Milan (Italie), le premier moteur andaineur de l'Europe, le « Velox ».
1972 : La décision de changer l'activité principale de la compagnie de la production de petites machines concentre tous les efforts et investissements dans la production et la distribution d'une large gamme de composants de découpage pour toutes sortes de machines de moisson. Cela marque également un changement au nom de la compagnie Ri.Ma, acronyme de « Ricambi Machine Agricole ».`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/rima1.jpg',
      'https://www.sae-dz.com/files/pagepart/rima2.jpg',
      'https://www.sae-dz.com/files/pagepart/rima3.jpg',
      'https://www.sae-dz.com/files/pagepart/rima4.jpg'
    ]
  },
  {
    id: 'mahle',
    name: 'MAHLE',
    country: 'Germany',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-mahle.jpg',
    website: 'https://www.mahle-aftermarket.com/eu/fr/catalog/',
    description: {
      en: 'MAHLE Aftermarket is present at 23 international sites. It has a total of 1,670 employees and achieves a turnover of 805 million euros.',
      fr: 'MAHLE Aftermarket est présente sur 23 sites internationaux. Elle compte au total de 1 670 employés et réalise un chiffre d\'affaires de 805 millions d\'euros.'
    },
    fullDescription: {
      en: `AGRO EQUIPEMENT is the official distributor of MAHLE products on the Algerian market.

MAHLE Aftermarket is present at 23 international sites. It has a total of 1,670 employees and achieves a turnover of 805 million euros.

Our five brands are synonymous with innovation and uncompromising quality: MAHLE Original, Knecht, Behr, Metal Leve and Clevite, the brand specializing in American commercial vehicles.

The MAHLE brand stands for engine parts and filters of impeccable quality, in both original equipment and aftermarket. This powerful brand is backed by a globally active Group with a brilliant research and development center, an efficient network of international production sites, and supplies the automotive equipment market with very high quality products.`,
      fr: `AGRO EQUIPEMENT est le distributeur officiel des produits MAHLE sur le marché Algérien.

MAHLE Aftermarket est présente sur 23 sites internationaux. Elle compte au total de 1 670 employés et réalise un chiffre d'affaires de 805 millions d'euros.

Nos cinq marques sont synonymes d'innovation et de qualité sans compromis : MAHLE Original, Knecht, Behr, Metal Leve et Clevite, la marque spécialisée dans les véhicules utilitaires américains.

La marque MAHLE est synonyme de pièces moteur et filtres à la qualité irréprochable, en première monte comme en après-vente.`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/mahle1.jpg'
    ],
    videoId: 'aykML9GjZGc'
  },
  {
    id: 'irischains',
    name: 'IRIS CHAINS',
    country: 'Spain',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-iris.jpg',
    website: 'https://www.iris-chains.com/moto/fr/garantie-chaines-iris-chains/',
    description: {
      en: 'Iris-Chains has been dedicated since its foundation in 1935 to the design and manufacture of high-performance roller chains, conveyor chains and agricultural chains.',
      fr: 'Iris-Chains se consacre depuis sa fondation en 1935 à la conception et fabrication des chaînes à rouleaux, des chaînes de transport et des chaînes agricoles de haute performance.'
    },
    fullDescription: {
      en: `Iris-Chains has been dedicated since its foundation in 1935 to the design and manufacture of high-performance roller chains, conveyor chains and agricultural chains, standard and special.

Thanks to its long-standing technical knowledge, manufacturing know-how and its very diversified product range, Iris chains have the capacity to offer reliable solutions to a wide range of global markets.

Commitment to Quality:
IRIS CHAINS is ISO 9001:2015 and ISO 14001:2015 certified.
These certifications reinforce the commitment to:
- Excellence and continuous improvement
- Customer and society demand for sustainability

The Iris Management System is independently reviewed and evaluated by Bureau Veritas.`,
      fr: `Iris-Chains se consacre depuis sa fondation en 1935 à la conception et fabrication des chaînes à rouleaux, des chaînes de transport et des chaînes agricoles de haute performance, standard et spéciales.

Grâce à ses connaissances techniques de longue date, à son savoir-faire de fabrication et à sa gamme de produits très diversifiée, les chaînes Iris ont la capacité d'offrir des solutions fiables à un large éventail de marchés mondiaux.

Engagement envers la qualité :
IRIS CHAINS est certifiée ISO 9001:2015 et ISO 14001:2015.
Ces certifications confortent l'engagement envers :
- L'excellence et l'amélioration continue
- La demande de durabilité des clients et la société`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/iris1.jpg',
      'https://www.sae-dz.com/files/pagepart/iris22.jpg',
      'https://www.sae-dz.com/files/pagepart/iris33.jpg'
    ]
  },
  {
    id: 'amgears-srl',
    name: 'AM GEARS SRL',
    country: 'Italy',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-euroricambi.jpg',
    website: 'https://www.euroricambigroup.com/fr',
    description: {
      en: 'The Antonio Masiero brand was born in 1954 in Bologna, the capital of the Italian metallurgical industry. This prestigious brand joined the Euroricambi group in 2010.',
      fr: 'La marque Antonio Masiero voit le jour en 1954 à Bologne, capitale de l\'industrie métallurgique italienne. Cette marque prestigieuse intègre le groupe Euroricambi en 2010.'
    },
    fullDescription: {
      en: `The tradition of a historic brand, the technology of a modern company

The Antonio Masiero brand was born in 1954 in Bologna, the capital of the Italian metallurgical industry. This prestigious brand joined the Euroricambi group in 2010 under a new name, but above all with new technologies and new equipment.`,
      fr: `La tradition d'une marque historique, la technologie d'une entreprise moderne

La marque Antonio Masiero voit le jour en 1954 à Bologne, capitale de l'industrie métallurgique italienne. Cette marque prestigieuse intègre le groupe Euroricambi en 2010 sous un nouveau nom, mais surtout avec de nouvelles technologies et de nouveaux équipements.`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/amgears1.jpg',
      'https://www.sae-dz.com/files/pagepart/amgears2.jpg',
      'https://www.sae-dz.com/files/pagepart/amgears3.jpg'
    ]
  },
  {
    id: 'motorservice',
    name: 'MS MOTORSERVICE',
    country: 'Germany',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-ms.jpg',
    website: 'https://www.ms-motorservice.fr/',
    description: {
      en: 'The Motorservice group is the commercial organization responsible for the global aftermarket activities of Rheinmetall Automotive.',
      fr: 'Le groupe Motorservice est l\'organisation commerciale chargée des activités aftermarket mondiales de Rheinmetall Automotive.'
    },
    fullDescription: {
      en: `Motorservice Group - Quality and Service from a single source

The Motorservice group is the commercial organization responsible for the global aftermarket activities of Rheinmetall Automotive. It is one of the leading suppliers of engine components for the independent spare parts market. With the premium brands Kolbenschmidt, Pierburg, TRW Engine Components and the BF brand, Motorservice offers its customers a wide and deep range of very high quality products from a single supplier.

IMA - Industry | Marine | Agriculture

With the KS Kolbenschmidt, Pierburg, BF and TRW Engine Components brands, MS Motorservice International GmbH guarantees uncompromising quality in the aftermarket in the fields of construction, agriculture and built-in engines.`,
      fr: `Groupe Motorservice - Qualité et Service d'une seule source

Le groupe Motorservice est l'organisation commerciale chargée des activités aftermarket mondiales de Rheinmetall Automotive. C'est l'un des premiers fournisseurs de composants moteurs pour le marché indépendant des pièces de rechange. Avec les marques haut de gamme Kolbenschmidt, Pierburg, TRW Engine Components ainsi que la marque BF, Motorservice propose à ses clients une gamme large et profonde, de très grande qualité.

IMA - Industry | Marine | Agriculture

Avec les marques KS Kolbenschmidt, Pierburg, BF et TRW Engine Components, la société MS Motorservice International GmbH se porte garante d'une qualité sans compromis sur le marché de la rechange dans les domaines de la construction, de l'agriculture et des moteurs incorporés.`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/ms1.jpg',
      'https://www.sae-dz.com/files/pagepart/ms2.jpg'
    ]
  },
  {
    id: 'fersa',
    name: 'FERSA',
    country: 'Spain',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-fersa.jpg',
    website: 'https://www.fersa.com/fr',
    description: {
      en: 'Fersa Bearings is a Spanish multinational dedicated to the design, development, manufacture and distribution of complete high-quality bearing solutions.',
      fr: 'Fersa Bearings est une multinationale espagnole dédiée à la conception, à l\'élaboration, à la fabrication et à la distribution de solutions complètes de roulements de haute qualité.'
    },
    fullDescription: {
      en: `Fersa Bearings is a Spanish multinational dedicated to the design, development, manufacture and distribution of complete high-quality bearing solutions. We have more than 50 years of experience in the sector and, since 2016, have been part of the Fersa Group together with the Austrian industrial bearings manufacturer, NKE.

True to our philosophy, we are a flexible, agile and dynamic company, focused on meeting the needs of a constantly changing market. The customer is our ultimate goal, which leads us to create specific solutions adapted to their needs.

We firmly believe in investing in innovation, technology and human resources as a driver of growth. This way of thinking has helped us grow day by day, thus becoming an international benchmark for quality and rigor.`,
      fr: `Fersa Bearings est une multinationale espagnole dédiée à la conception, à l'élaboration, à la fabrication et à la distribution de solutions complètes de roulements de haute qualité. Nous avons plus de 50 ans d'expérience dans le secteur et, depuis 2016, font partie du Fersa Group conjointement avec le fabricant autrichien de roulements industriels, NKE.

Fidèle à notre philosophie, nous sommes une entreprise flexible, agile et dynamique, axée sur la satisfaction des besoins d'un marché en pleine mutation. Le client est notre but ultime, ce qui nous conduit à créer des solutions spécifiques adaptées à leurs besoins.

Nous croyons fermement à investir dans l'innovation, la technologie et les ressources humaines comme moteur de la croissance.`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/fersa1.jpg',
      'https://www.sae-dz.com/files/pagepart/fersa2.jpg'
    ]
  },
  {
    id: 'ntnsnr',
    name: 'NTN SNR',
    country: 'France',
    logo: 'https://www.sae-dz.com/files/partenaires/logo-ntnsnr.jpg',
    website: 'https://www.ntn-snr.com/fr',
    description: {
      en: 'NTN SNR EUROPE is a world leader for bearings, transmission joints, linear modules, timing pulleys, suspension parts, associated services and training.',
      fr: 'NTN SNR EUROPE est leader mondial pour les roulements, joints de transmission, modules linéaires, galets de distribution, pièces de suspension, services et formations associées.'
    },
    fullDescription: {
      en: `NTN SNR EUROPE is a world leader for bearings, transmission joints, linear modules, timing pulleys, suspension parts, associated services and training.

NTN SNR EUROPE designs, develops and industrializes its products. The NTN and SNR brands are benchmarks in both OEM and Aftermarket. Innovation is at the heart of our concerns, whatever your industry: aeronautics, automotive, cement, wind power, rail, machine tools, textile machines, agricultural machinery, construction machinery, mines and quarries, vacuum pumps, steel industry...

Why choose the NTN-SNR range for your standard INDUSTRIAL products?

The NTN-SNR INDUSTRIAL standard range is the largest standardized range on the market. Standard bearings, housings and accessories used in original equipment or replacement are presented here.`,
      fr: `NTN SNR EUROPE est leader mondial pour les roulements, joints de transmission, modules linéaires, galets de distribution, pièces de suspension, services et formations associées.

NTN SNR EUROPE conçoit, développe et industrialise ses produits. Les marques NTN et SNR font figure de référence, aussi bien sur les marchés OEM qu'en Rechange. L'innovation est au cœur de nos préoccupations, quelle que soit votre industrie : aéronautique, automobile, cimenterie, éolien, ferroviaire, machines-outils, machines textiles, machinisme agricole, machines de construction, mines et carrières, pompes à vide, sidérurgie…

Pourquoi choisir la gamme NTN-SNR pour vos produits standards INDUSTRIE ?

La gamme standard INDUSTRIE de NTN-SNR est la gamme normalisée la plus large du marché.`
    },
    images: [
      'https://www.sae-dz.com/files/pagepart/ntn1.jpg',
      'https://www.sae-dz.com/files/pagepart/ntn2.jpg',
      'https://www.sae-dz.com/files/pagepart/ntn3.jpg'
    ]
  }
];

export const additionalPartners = [
  { name: 'BF GERMANY', logo: 'https://www.sae-dz.com/files/represantant/logo-bfgermany.jpg', website: 'https://www.ms-motorservice.com/fr/entreprise/nos-marques/bf/' },
  { name: 'ELKAR', logo: 'https://www.sae-dz.com/files/represantant/logo-elkar.jpg', website: 'https://www.elkaroto.com/fr/maison/' },
  { name: 'EURORICAMBI', logo: 'https://www.sae-dz.com/files/represantant/logo-euroricambi.jpg', website: 'https://www.euroricambigroup.com/fr' },
  { name: 'TAGEX', logo: 'https://www.sae-dz.com/files/represantant/logo-tagex.jpg', website: 'https://tagex.com/gummiketten/gummiketten/1/fr' }
];

export const references = [
  { id: 1, image: 'https://www.sae-dz.com/files/references/ref1.jpg' },
  { id: 2, image: 'https://www.sae-dz.com/files/references/ref2.jpg' },
  { id: 3, image: 'https://www.sae-dz.com/files/references/ref3.jpg' },
  { id: 4, image: 'https://www.sae-dz.com/files/references/ref4.jpg' },
  { id: 5, image: 'https://www.sae-dz.com/files/references/ref5.jpg' },
  { id: 6, image: 'https://www.sae-dz.com/files/references/ref6.jpg' },
  { id: 7, image: 'https://www.sae-dz.com/files/references/ref7.jpg' }
];

export const equipmentCategories = [
  {
    id: 'sampo',
    name: { en: 'SAMPO Parts', fr: 'Pièces SAMPO' },
    images: [
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=600&q=80',
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80',
      'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&q=80',
      'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=600&q=80',
      'https://images.unsplash.com/photo-1537462715879-360eeb61a0ad?w=600&q=80',
      'https://images.unsplash.com/photo-1605000797499-95a51c5269ae?w=600&q=80'
    ]
  },
  {
    id: 'claas',
    name: { en: 'CLAAS Parts', fr: 'Pièces CLAAS' },
    images: [
      'https://images.unsplash.com/photo-1530267981375-f0de937f5f13?w=600&q=80',
      'https://images.unsplash.com/photo-1589923188651-268a9765e432?w=600&q=80',
      'https://images.unsplash.com/photo-1599033329459-cc8c31c7eb6c?w=600&q=80',
      'https://images.unsplash.com/photo-1605000797499-95a51c5269ae?w=600&q=80',
      'https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=600&q=80',
      'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&q=80'
    ]
  },
  {
    id: 'tractors',
    name: { en: 'Tractor Parts', fr: 'Pièces Tracteurs' },
    images: [
      'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&q=80',
      'https://images.unsplash.com/photo-1585911171167-1f66ea3de00c?w=600&q=80',
      'https://images.unsplash.com/photo-1562051036-e0eea191d42f?w=600&q=80',
      'https://images.unsplash.com/photo-1593179532737-bc9e35e27c26?w=600&q=80',
      'https://images.unsplash.com/photo-1589923188651-268a9765e432?w=600&q=80',
      'https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=600&q=80'
    ]
  },
  {
    id: 'skf',
    name: { en: 'SKF Bearings', fr: 'Roulements SKF' },
    images: [
      'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=600&q=80',
      'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600&q=80',
      'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=600&q=80',
      'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&q=80',
      'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&q=80',
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=600&q=80'
    ]
  }
];

export const heroSlides = [
  'https://www.sae-dz.com/files/slider/anim1.jpg',
  'https://www.sae-dz.com/files/slider/anim2.jpg',
  'https://www.sae-dz.com/files/slider/anim3.jpg',
  'https://www.sae-dz.com/files/slider/anim4.jpg',
  'https://www.sae-dz.com/files/slider/anim5.jpg'
];
